import React, { useEffect, useRef } from "react";

import { withBreakpoints } from "@utils/breakpoints/breakpoints.provider";

import { withWoosMap } from "@services/woosmap/woosmap.initializer";

import { Messages } from "@components/General/Messages/messages.container";

import { useWoosmap } from "./hooks/useWoosmap.hook";
import { StoreSearchComponent } from "./storeSearch.component";
import { StoreSearchContextProvider } from "./storeSearch.context";
import "./storeSearch.scss";
import { StoreUrl } from "./storeSearch.types";

export type StoreSearchContainerProps = {
    storeUrls: Array<StoreUrl>;
    storeFeatures: Array<string>;
};

const StoreSearchContainer = ({
    storeUrls,
    storeFeatures,
}: StoreSearchContainerProps) => {
    const mapElementRef = useRef<HTMLDivElement>(null);

    const {
        searchItem,
        selectedStore,
        handleUrl,
        stores,
        resetSearchItem,
        storesLoading,
    } = useWoosmap({
        mapElementRef,
        storeUrls: storeUrls,
    });

    useEffect(() => {
        handleUrl();
    }, []);

    return (
        <StoreSearchContextProvider
            stores={stores}
            storesLoading={storesLoading}
            selectedStore={selectedStore}
            selectedSearchItem={searchItem}
            handleUrl={handleUrl}
            storeFeatures={storeFeatures}
            storeUrls={storeUrls}
            resetSearchItem={resetSearchItem}
        >
            <Messages messageid="storesearch-locator-error" />
            <StoreSearchComponent mapElementRef={mapElementRef} />
        </StoreSearchContextProvider>
    );
};

const StoreSearchSkeleton = () => (
    <article className={"store-search store-search--skeleton"} />
);

const StoreSearch = withBreakpoints(
    withWoosMap(StoreSearchContainer, StoreSearchSkeleton),
    StoreSearchSkeleton,
);

export { StoreSearch };
